// ALSA PRO Logo Component - Using vector SVG
const AlsaProLogo = ({ className = "", size = "normal" }) => {
  // Size configurations
  const sizes = {
    small: "h-8",
    normal: "h-10",
    large: "h-14"
  };

  const heightClass = sizes[size] || sizes.normal;

  return (
    <img 
      src="/alsa-pro-logo.svg" 
      alt="ALSA PRO"
      className={`${heightClass} w-auto object-contain ${className}`}
    />
  );
};

export default AlsaProLogo;
